const FALLBACK_IMAGE =
  "https://www.kindacode.com/wp-content/uploads/2021/08/oops.png";

const pinataImageURL =
  "https://bafybeigfxvhuht4tentzgl2r64ipyadskl3vfc544bci2mejd5zby23ugy.ipfs.infura-ipfs.io/";

export const imageOnLoadHandler = (event) => {
  if (event.currentTarget.className !== "error") {
    event.currentTarget.className = "success";
  }
};

export const imageOnErrorHandler = (event) => {
  event.currentTarget.src = FALLBACK_IMAGE;
  event.currentTarget.className = "error";
};

export const getPinataUrl = (pathname) => {
  return `${pinataImageURL}${pathname}`;
};
